import { SharedModule } from '../components/common/common.module.client'
import { GdClientModule } from '@glidecms/deliver-core-dev/gd-module/gd-client-module.decorator'
import { WMoreOnThisCCD } from './article/more-on-links/_ccs'
import { AuthorCCD } from './article/author/_ccd'
import { WHeroImageCCD } from './article/hero-image/_ccd'
import { IntroParagraphCCD } from './article/intro-paragraph/_ccd'
import { ArticleHeaderCCD } from './article/header/_ccd'
import { WJumpLinksCCD } from './article/jump-links/_ccd'
import { WArticleBodyNewsCCD } from './article/copy/_ccd'
import { WEmbedGalleryCCD } from './article/embed-gallery/_ccd'
import { WArticleBodyImageCCD } from './article/embed-image/_ccd'
import { WArticleTaxonomiesCCD } from './article/tags/_ccd'
import { WBrightcoveCCD } from './article/embed-brightcove/_ccd'
import { WSharingOptionsVerticalCCD } from './article/share-vertical/_ccd'
import { WSharingOptionsHorizontalCCD } from './article/share-horizontal/_ccd'
import { RelatedArticleLinksCCD } from './article/related-article-links/_ccd'
import { WLatestNewsCCD } from './article/latest-news/_ccd'
import { WNonFeaturedArticlesCCD } from './article-listing/non-featured/_ccd'
import { WArticleListingPageHeaderCCD } from './article-listing/header/_ccd'
import { WBreadcrumbCCD } from './global/breadcrumb/_ccd'
import { WMultiPageGuidesCCD } from './article/mpg-links/_ccd'
import { WArticleListingFeaturedArticlesCCD } from './article-listing/featured/_ccd'
import { WSuperCategorySectionCCD } from './subvertical/super-categories/_ccd'
import { WSubVerticalHeaderCCD } from './subvertical/header/_ccd'
import { WSubVerticalJumpLinksCCD } from './subvertical/jump-links/_ccd'
import { AffiliateDisclaimerCCD } from './article/affiliate-disclaimer/_ccd'
import { ConversionBannerCCD } from './article/conversion-banner/_ccd'
import { WAccordion } from './article/embed-accordion/_ccd'
import { WFactsCCD } from './article/embed-facts/_ccd'
import { WDataLayerScriptCCD } from './global/data-layer/_ccd'

//Vertical components
import {
  VerticalAdviceCardsCCD,
  VerticalHeaderCCD,
  VerticalLatestNewsCCD,
  VerticalSubVerticalLinksCCD,
  VerticalArticleCardsCCD,
} from './vertical'

import { CommonModule } from '@glidecms/deliver-components-dev/common/common.module.client'
import { MediaModule } from '@glidecms/deliver-components-dev/media/media-components.module.client'
import { ContentModule } from '@glidecms/deliver-components-dev/content/content-components.module.client'

@GdClientModule({
  declarations: [
    WHeroImageCCD,
    IntroParagraphCCD,
    ArticleHeaderCCD,
    WJumpLinksCCD,
    WArticleBodyNewsCCD,
    WEmbedGalleryCCD,
    WArticleBodyImageCCD,
    WArticleTaxonomiesCCD,
    WSharingOptionsVerticalCCD,
    WSharingOptionsHorizontalCCD,
    AuthorCCD,
    WBrightcoveCCD,
    WMoreOnThisCCD,
    RelatedArticleLinksCCD,
    WLatestNewsCCD,
    WNonFeaturedArticlesCCD,
    WArticleListingPageHeaderCCD,
    WMultiPageGuidesCCD,
    WArticleListingFeaturedArticlesCCD,
    WBreadcrumbCCD,
    WSuperCategorySectionCCD,
    WSubVerticalHeaderCCD,
    WSubVerticalJumpLinksCCD,
    VerticalAdviceCardsCCD,
    VerticalHeaderCCD,
    VerticalLatestNewsCCD,
    VerticalSubVerticalLinksCCD,
    VerticalArticleCardsCCD,
    AffiliateDisclaimerCCD,
    ConversionBannerCCD,
    WAccordion,
    WFactsCCD,
    WDataLayerScriptCCD,
  ],
  imports: [SharedModule, CommonModule, MediaModule, ContentModule],
  bootstrapComponentName: 'MasterLayout',
})
export class AppModuleClient {}
